<script setup lang="ts">
import { gwtBridge } from '@/GWTBridge';
import { Dialog } from 'primevue'
import { ref } from "vue";
import ThemeSelector from "@/components/ThemeSelector.vue"

let visible = ref(false);
let buildDate = ref("");

gwtBridge.then((bridge) => {
    buildDate.value = bridge.buildDate;
});

</script>

<template>
    <footer class="app-footer flex bg-surface-200 dark:bg-surface-800 border-t border-surface-500 justify-between text-sm px-2">
        <ThemeSelector/>
        <div id="brightside-info">
            <a @click.prevent="visible = true" class="cursor-pointer">Brightside</a> - Copyright &copy; 2010-{{new Date().getFullYear()}}
        </div>
        <div class="md:inline-block hidden" id="review-link">
            <a href="https://reviews.capterra.com/products/new/8a71534d-a035-49ea-8433-a81d005a942b/dd0b8080-6fc3-4ef2-a0a9-d5f182fd4970?lang=en" target="_blank">Review BrightSide to Earn $10!</a>
        </div>
        <Dialog v-model:visible="visible" modal header="About Brightside" dismissable-mask :style="{ width: '20rem' }">
            <div v-if="buildDate !== ''">Build Date: {{buildDate}}</div>
            <a href="https://bookonthebrightside.com/release-notes/" target="_blank">Release Notes</a>
        </Dialog>
    </footer>
</template>

<style>
@media print {
    .app-footer {
        display: none;
    }
}
</style>